import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const channelsMapping = buildGetterObject('channelsMapping');
export const channels = buildGetterObject('channels');
export const channelAuthInfo = buildGetterObject('channelAuthInfo');

export const isForcedCompare = (a, b) => (b.is_forced ? 1 : -1);

const getters = {
	[channelsMapping.getter]: ({ channels }) => channels,
	[channels.getter]: (state, getters) => Object.values(getters[channelsMapping.getter] || {}).sort(isForcedCompare),
	[channelAuthInfo.getter]: (state, getters) => {
		const result = [];
		getters[channels.getter]
			.filter((c) => c.requires_cred)
			.forEach(({ service, service_version, service_version_id }) => {
				if (!result.find((c) => service_version_id === c.service_version_id)) {
					result.push({ service, service_version, service_version_id });
				}
			});
		return result;
	},
};

export default getters;
